import { render, staticRenderFns } from "./DANA.vue?vue&type=template&id=584232e6&scoped=true"
import script from "./DANA.vue?vue&type=script&lang=js"
export * from "./DANA.vue?vue&type=script&lang=js"
import style0 from "./DANA.vue?vue&type=style&index=0&id=584232e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584232e6",
  null
  
)

export default component.exports